import React from 'react';
import type { PreviewType, FlowGraphData } from '../types/protocol';
import { FlowPreview } from './FlowPreview';

interface PreviewRendererProps {
  previewType: PreviewType;
  data: unknown;
  label?: string;
}

/**
 * Registry that maps previewType → React component.
 * Extensible: add new preview types here without changing ChatPanel.
 */
export function PreviewRenderer({ previewType, data, label }: PreviewRendererProps): React.ReactElement {
  switch (previewType) {
    case 'flow_graph':
      return <FlowPreview data={data as FlowGraphData} label={label} />;

    case 'summary_table':
      return (
        <div className="sp-preview-generic">
          {label && <h4 className="sp-preview-label">{label}</h4>}
          <pre className="sp-preview-data">{JSON.stringify(data, null, 2)}</pre>
        </div>
      );

    case 'schedule_view':
      return (
        <div className="sp-preview-generic">
          {label && <h4 className="sp-preview-label">{label}</h4>}
          <pre className="sp-preview-data">{JSON.stringify(data, null, 2)}</pre>
        </div>
      );

    default:
      return (
        <div className="sp-preview-generic">
          {label && <h4 className="sp-preview-label">{label}</h4>}
          <pre className="sp-preview-data">{JSON.stringify(data, null, 2)}</pre>
        </div>
      );
  }
}
